import React, { useState, useMemo } from 'react';
import TaskCard from '../../components/TaskCard/TaskCard';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { useSelectedStudent } from '../../context/SelectedStudentContext';
import { useTasklist } from '../../context/TasklistContext';
import { useOverviewContext } from '@/context/OverviewContext';
import { studentPreviewRole } from '@/utils/toolSettingsUtils';

const SchoolPrepChecklist = () => {

    const { userRoleVal: accountRoleVal } = useOverviewContext();
    const userRoleVal = studentPreviewRole(accountRoleVal);
    const { selectedStudent } = useSelectedStudent();
    const { tasklistData, tasklistTopicStatus } = useTasklist();

    const displayName = selectedStudent?.nickName || selectedStudent?.firstName || '';
    const isLC = userRoleVal === 'LEARNING_COACH';
    const role = isLC ? 'LEARNING_COACH' : 'STUDENT';

    const dynamicTasks = useMemo(() => {
          if (!selectedStudent) return [];

          const studentChecklistStatus = tasklistTopicStatus.filter(
            s => String(s.accountId) === String(selectedStudent.accountId)
          );

          return tasklistData.map(item => {
            const status = studentChecklistStatus.find(
              s => s.checklistId === item.checklistId
            );
            return {
              id: item.checklistId,
              checklistName: item.checklistName || '',
              title: item.description || 'Untitled Task',
              completed: status?.status === 'true',
              pageId: item.pageId,
              pathSegment: item.pathSegment,
            };
          });
        }, [tasklistData, tasklistTopicStatus, selectedStudent]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalTasks = dynamicTasks.length;

    const breadcrumbItems = [
        { title: "Home", path: "/" },
        { title: "School Prep Checklist" }
    ];

    return (
        <>
        <div className="school-prep-container">
            <Breadcrumb items={breadcrumbItems} />
            <div className='hero'>
                <div className='hero-content'>
                    <h1 className='hero-title'>School Prep Checklist</h1>
                    <p className='hero-desc'>While you wait to hear from your school, here are a few things you can do to get ready for school.</p>
                </div>
                <TaskCard tasks={dynamicTasks} role={role} displayName={displayName} />
            </div>

        </div>
        </>
    );
};

export default SchoolPrepChecklist;